import React, {useState} from 'react';
import {useDispatch} from 'react-redux';

import {deleteHistory, updateHistoryInfo} from '../../../../modules/chat/chat';

import {ClickAwayListener, MenuItem, MenuList, ListItemIcon, ListItemText, Paper, Popper} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';

import DeleteModal from './DeleteModal';

export default function HistoryMenuBox({ open, anchorEl, historyId, isPinned, onClickEditTitle, onClose }) {
    const dispatch = useDispatch();

    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

    const handleClickPin = () => {
        dispatch(updateHistoryInfo({ id: historyId, data: { isPinned: !isPinned } }));
    };

    const toggleDeleteModal = () => {
        setIsOpenDeleteModal(!isOpenDeleteModal);
    };

    const handleClickDelete = () => {
        dispatch(deleteHistory({ id: historyId }));
    };

    const historyMenuItems = [
        {
            key: 'pin',
            label: isPinned ? '고정 해제' : '고정',
            icon: isPinned ? <CloseRoundedIcon fontSize='small' /> : <PushPinOutlinedIcon fontSize='small' />,
            onClick: handleClickPin
        },
        {
            key: 'update-title',
            label: '제목 변경',
            icon: <ModeEditOutlinedIcon fontSize='small' />,
            onClick: onClickEditTitle
        },
        {
            key: 'delete',
            label: '삭제',
            icon: <DeleteOutlineRoundedIcon fontSize='small' />,
            onClick: toggleDeleteModal
        }
    ];

    return (
        <>
            <Popper
                open={open}
                anchorEl={anchorEl}
                placement='right-start'
                sx={{ zIndex: 1300 }}
            >
                <ClickAwayListener onClickAway={onClose}>
                    <Paper>
                        <MenuList sx={{ width: 160, py: '8px', bgcolor: 'background.paper', border: 1, borderColor: 'elevation.outlined', borderRadius: 1, boxShadow: 0, position: 'absolute', left: 'calc(100% + 20px)', bottom: '-100px', zIndex: 10 }}>
                            {historyMenuItems.map((item) => {
                                const { key, label, icon, onClick } = item;

                                return (
                                    <MenuItem
                                        key={key}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onClick?.();
                                        }}
                                    >
                                        <ListItemIcon>{icon}</ListItemIcon>
                                        <ListItemText
                                            primary={label}
                                            primaryTypographyProps={{ variant: 'subtitle3' }}
                                        />
                                    </MenuItem>
                                );    
                            })}
                        </MenuList>
                    </Paper>
                </ClickAwayListener>
            </Popper>
            {isOpenDeleteModal &&
                <DeleteModal
                    historyId={historyId}
                    isOpen={isOpenDeleteModal}
                    onClose={toggleDeleteModal}
                    onDelete={handleClickDelete}
                />
            }
        </>
    );
}
